import { Link } from "react-router-dom";
import { animeList, categories } from "@/mocks/anime";

const colorClasses: Record<string, string> = {
  primary: "bg-primary-100 text-primary-700",
  accent: "bg-accent-100 text-accent-800",
  secondary: "bg-secondary-100 text-secondary-700",
};

export default function CategoryEntries() {
  return (
    <section className="w-full px-4 md:px-8 py-10 md:py-14">
      <div className="flex items-end justify-between mb-6">
        <div>
          <h2 className="font-heading font-extrabold text-foreground-950 text-2xl md:text-3xl">
            分类快捷入口
          </h2>
          <p className="mt-1.5 text-sm text-foreground-500">
            按类型快速找到你想看的动漫作品
          </p>
        </div>
        <Link
          to="/category/hotblood"
          className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-600 font-medium hover:text-primary-700 transition-colors whitespace-nowrap"
        >
          全部分类
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
        {categories.map((cat) => {
          const count = animeList.filter((a) => a.category === cat.name).length;
          return (
            <Link
              key={cat.id}
              to={`/category/${cat.id}`}
              className="group bg-background-50 border border-background-200 rounded-lg p-4 hover:border-primary-300 transition-colors"
            >
              <span className={`w-10 h-10 flex items-center justify-center rounded-lg ${colorClasses[cat.color]}`}>
                <i className={`${cat.icon} text-xl`}></i>
              </span>
              <h3 className="mt-3 font-heading font-bold text-foreground-950 text-sm md:text-base group-hover:text-primary-600 transition-colors">
                {cat.name}
              </h3>
              <p className="mt-1 text-xs text-foreground-500 line-clamp-2 leading-relaxed hidden sm:block">
                {cat.description}
              </p>
              <span className="mt-2 inline-block text-[11px] text-foreground-400">
                {count} 部作品
              </span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}